/**
 * TypeScript types for the authority validation framework (TASK-159 / AV-01).
 *
 * Mirrors the API contract defined in
 * `docs/plans/task-159-validation-framework-team.md` so consumers (services,
 * hooks, components) stay decoupled from raw response shapes and can be
 * refactored on either side independently.
 *
 * Backend persists the validation state on the record itself and exposes:
 *  - `POST /czna-authorities/validation/validate-record` (ad-hoc preview, no DB writes)
 *  - `POST /czna-authorities/validation/revalidate`     (kick off async bulk job)
 *  - `GET  /czna-authorities/validation/revalidate/{id}`(poll job status)
 *
 * In addition, list/save endpoints carry validation-status fields on each
 * record summary and may return 422 with a `validationResult` payload on
 * save attempts that would create a BLOCKING-error record.
 */
/** Terminal job states for polling exit. */
export var TERMINAL_JOB_STATES = new Set([
    'COMPLETED',
    'FAILED',
    'CANCELLED',
]);
